import { render, staticRenderFns } from "./DetailsRequestData.vue?vue&type=template&id=22b054ae&scoped=true"
import script from "./DetailsRequestData.vue?vue&type=script&lang=js"
export * from "./DetailsRequestData.vue?vue&type=script&lang=js"
import style0 from "./DetailsRequestData.vue?vue&type=style&index=0&id=22b054ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b054ae",
  null
  
)

export default component.exports